export const SKILL_ITEM_KINDS = [
  { code: 'skill', name: 'Savoir-faire' }, { code: 'tool', name: 'Logiciels et outils' },
  { code: 'knowledge', name: 'Connaissances' }, { code: 'sector', name: 'Expériences sectorielles' },
];
export const getSkillKindLabel = code => SKILL_ITEM_KINDS.find(kind => kind.code === code)?.name || 'Savoir-faire';
export const normalizeCatalogSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
export const catalogDomains = skill => [...new Map([...(skill.expertiseDomains || []), skill.ExpertiseDomain, skill.expertiseDomain].filter(Boolean).map(domain => [Number(domain.id), domain])).values()];
export const domainFilterIds = (domains, selected) => {
  const ids = new Set([Number(selected)]);
  let changed = true;
  while (changed) {
    changed = false;
    for (const domain of domains) if (ids.has(Number(domain.parentId)) && !ids.has(Number(domain.id))) { ids.add(Number(domain.id)); changed = true; }
  }
  return ids;
};
export const domainLabel = domain => domain.shortName && domain.shortName !== domain.name ? `${domain.name} (${domain.shortName})` : domain.name;

export const canReviewSkillCatalog = (user = {}) => Number(user?.roleId) === 1 || ['admin', 'hr', 'rh'].includes(String(user?.role || '').trim().toLowerCase());
